import { UserRoleEnum } from "../enums/User/UserRoleEnum";

export const CHAT_PATH = "/chats/reply";

// Mesma regra do MainNavbar para exibir o link "IA Beviajuda".
export const canAccessChat = (user: any): boolean =>
  user?.role === UserRoleEnum.ADMIN || user?.access_profile?.id !== 2;

// Telas que o usuário mobile pode abrir; qualquer outra volta para o chat.
const MOBILE_ALLOWED_PATHS = [CHAT_PATH, "/chats/tutorial"];

export const isPathAllowedOnMobile = (pathname: string): boolean =>
  MOBILE_ALLOWED_PATHS.includes(pathname.replace(/\/+$/, ""));

// Depois do login, no mobile o usuário vai direto para o chat da IA.
export const getPostLoginPath = (
  user: any,
  isMobile: boolean,
  defaultPath: string,
): string => (isMobile && canAccessChat(user) ? CHAT_PATH : defaultPath);
